import { logger } from '../../../helpers/logger';

/** The HP demo rows, fetched as their own chunk the first time they're needed. */
export const loadHpDemoTelemetry = () => import('./hpDemoTelemetry');

/**
 * What an HP search shows: `rows`/`keys` on the chart, and the daily rows a
 * zoom-in switches to (data consumption has no zoom level).
 */
export const hpDemoRows = (system, data) => {
  if (system === 'hpDc') {
    const { dailyData, dailyKeys } = data.hpDataConsumpData;
    return { rows: dailyData, keys: dailyKeys, dailyRows: [], dailyKeys: [] };
  }
  const set = system === 'hpGc' ? data.hpGasData : data.hpElectricData;
  return {
    rows: set.monthlyData,
    keys: set.monthlyKeys,
    dailyRows: set.dailyData,
    dailyKeys: set.dailyKeys,
  };
};

/** Bumps `ref` and returns a check that stays true until the next bump. */
export const startLatestRequest = (ref) => {
  ref.current += 1;
  const request = ref.current;
  return () => request === ref.current;
};

/**
 * Hands the loaded HP demo data to `apply` only while `isLatest()` says no
 * newer search or zoom has started; a failed load is logged and applies nothing.
 */
export const applyLatestHpDemo = (loading, isLatest, apply) =>
  loading
    .then((data) => {
      if (isLatest()) {
        apply(data);
      }
    })
    .catch((error) => {
      logger.error('Could not load the heating-platform demo telemetry:', error);
    });
